import type { CursorAgentMessage } from './cursorAgentHistory';

/** True when the UI should show a thinking state and poll the agent on load. */
export function shouldResumeAgentChat(messages: CursorAgentMessage[]): boolean {
  if (messages.length === 0) return false;
  const last = messages[messages.length - 1]!;
  if (last.role === 'user') return true;
  if (last.role === 'assistant') {
    const t = last.text.trim();
    return t === 'Thinking…' || t.startsWith('Thinking…');
  }
  return false;
}
